import { createContext, useContext, type ReactNode } from 'react';

import { fetchSurveysGateway } from '../api/fetchSurveysGateway';
import type { SurveysGateway } from '../ports/surveysGateway';

/**
 * Which backend the survey hooks talk to. It defaults to the real one, so the
 * app mounts no provider; a test mounts one holding an in-memory gateway.
 */
const SurveysGatewayContext = createContext<SurveysGateway>(fetchSurveysGateway);

export function SurveysGatewayProvider({
  gateway,
  children,
}: {
  gateway: SurveysGateway;
  children: ReactNode;
}) {
  return (
    <SurveysGatewayContext.Provider value={gateway}>{children}</SurveysGatewayContext.Provider>
  );
}

export function useSurveysGateway() {
  return useContext(SurveysGatewayContext);
}
